// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yjlreilmimvifaftqzwr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqbHJlaWxtaW12aWZhZnRxendyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzMjAwMjYsImV4cCI6MjA2Mzg5NjAyNn0.Yu4T_b0UseGwCzb6dLeAqrDlei6Zw3MuxHqAm04_76I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);